import { render, staticRenderFns } from "./BasicFormGroup.vue?vue&type=template&id=c38b9bac"
import script from "./BasicFormGroup.vue?vue&type=script&lang=js"
export * from "./BasicFormGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports